<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
  [fullScreen]="true">
  <span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
  </span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
    <!--begin::Page title-->
    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading mt-0 mb-0">
          <svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_1246_5488)">
              <path
                d="M29.4039 6.27336C23.7017 5.61371 20.5709 3.99455 18.2138 0.504383C18.1038 0.348431 17.9583 0.221273 17.7895 0.133529C17.6207 0.0457841 17.4335 0 17.2436 0C17.0537 0 16.8665 0.0457841 16.6977 0.133529C16.529 0.221273 16.3835 0.348431 16.2734 0.504383C13.6544 3.94658 10.4284 5.63769 5.04761 6.27336C4.75725 6.30871 4.48997 6.45052 4.29676 6.67173C4.10354 6.89294 3.99792 7.17807 4.00003 7.47273V11.9704C4.00003 21.0016 9.10699 27.0105 16.5948 30.9564C16.784 31.0756 17.0026 31.1387 17.2257 31.1387C17.4489 31.1387 17.6675 31.0756 17.8567 30.9564C19.7614 29.6971 22.8565 28.054 24.4279 26.3988C26.3414 24.5316 27.8612 22.2944 28.8962 19.8214C29.9312 17.3483 30.4602 14.6903 30.4515 12.0064V7.46074C30.4507 7.16814 30.3437 6.88594 30.1508 6.66725C29.9578 6.44856 29.6922 6.30847 29.4039 6.27336ZM20.2375 26.6627L17.2257 28.5457C15.4231 27.5249 13.7035 26.3619 12.0831 25.0675C12.1958 24.3334 12.5164 23.6476 13.0062 23.0924C13.4961 22.5372 14.1345 22.1361 14.8449 21.9372C15.0544 21.8818 15.2449 21.7698 15.3959 21.6135C15.547 21.4571 15.6528 21.2621 15.702 21.0496C15.9639 20.0062 14.5116 19.5504 14.6663 18.5309V14.7769C14.6725 14.3081 14.8601 13.8602 15.1892 13.5286C15.5182 13.1971 15.9628 13.008 16.4282 13.0018H18.0472C18.5093 13.0112 18.9496 13.202 19.2742 13.5335C19.5988 13.8651 19.7822 14.3112 19.7852 14.7769V18.5309C19.9161 19.5624 18.4995 19.9942 18.7614 21.0376C18.8077 21.2509 18.9109 21.4473 19.0598 21.6058C19.2088 21.7643 19.3978 21.8789 19.6066 21.9372C20.321 22.1342 20.9623 22.5381 21.4511 23.0988C21.9399 23.6595 22.2547 24.3523 22.3565 25.0915C21.6976 25.6808 20.9885 26.2105 20.2375 26.6747V26.6627Z"
                fill="#265D91" />
            </g>
            <defs>
              <filter id="filter0_d_1246_5488" x="0" y="0" width="34.4531" height="39.1388" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1246_5488" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1246_5488" result="shape" />
              </filter>
            </defs>
          </svg>

          Notre compte
        </h1>

        <!--begin::Menu-->

      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a routerLink="/accueil" class="text-muted ">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">Notre compte</li>
        <!-- <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Liste des abonnements</li> -->
        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>

<div id="kt_app_content" class="app-content flex-column-fluid mb-15">
  <div id="kt_app_content_container" class="app-container container-fluid">
    <div class="card">
      <div class="card-body">
        <div class="title mb-3 d-flex justify-content-between">
          <h4>Recherche</h4>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="input-group search-libre">
              <span class="input-group-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                    fill="#7E7C7C" />
                </svg>
              </span>

                <input type="text" data-kt-customer-table-filter="search" [(ngModel)]="searchElement"
                class="form-control ps-5" placeholder="Rechercher" />

              <div class="tooltip-container tooltip-info">
                <div class="tooltip-trigger">
                  <i class="fa-solid fa-circle-info" style="font-size: 20px"></i>
                </div>
                <div class="tooltip-content">
                  <div class="content">
                    <h4>Opérateur AND :</h4>
                    <p>
                      Utilisez l'opérateur AND pour spécifier que les
                      résultats doivent inclure plusieurs termes.
                    </p>
                    <p>
                      Exemple : software AND engineer renverra des profils
                      qui mentionnent à la fois "software" et "engineer".
                    </p>
                    <h4>Opérateur OR :</h4>
                    <p>
                      Utilisez l'opérateur OR pour spécifier que les
                      résultats peuvent inclure l'un des termes.
                    </p>
                    <p>
                      Exemple : sales OR marketing renverra des profils
                      qui mentionnent soit "sales" soit "marketing".
                    </p>
                    <h4>Opérateur NOT :</h4>
                    <p>
                      Utilisez l'opérateur NOT pour exclure des termes
                      spécifiques des résultats.
                    </p>
                    <p>
                      Exemple : developer NOT manager renverra des profils
                      qui mentionnent "developer" mais pas "manager".
                    </p>
                    <h4>Guillemets pour une expression exacte :</h4>
                    <p>
                      Utilisez des guillemets pour rechercher une
                      expression exacte.
                    </p>
                    <p>
                      Exemple : "product manager" renverra des profils qui
                      mentionnent exactement "product manager".
                    </p>
                    <h4>Parenthèses pour grouper des opérations :</h4>
                    <p>
                      Utilisez des parenthèses pour définir l'ordre
                      d'évaluation des opérations.
                    </p>
                    <p>
                      Exemple : (sales OR marketing) AND manager renverra
                      des profils qui mentionnent "sales" ou "marketing"
                      et "manager".
                    </p>
                    <h4>Recherche standard :</h4>
                    <p>
                      Si aucun opérateur n'est spécifié dans la recherche,
                      le texte sera interprété comme s'il était entre
                      guillemets.
                    </p>
                    <p>
                      Exemple : La recherche product manager sera traitée
                      comme "product manager", suivant la règle 4.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-lg-6">
            <div class="search-btn" style="float: right">
              <div class="mb-3  d-flex justify-content-end">
                <div class="align-items-center recherche">
                  <!-- Bouton Submit -->
                  <button type="submit" class="me-5" (click)="currentPage=0; getListAbonnement(true);">
                    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                        fill="white" />
                    </svg>
                    Rechercher
                  </button>
                </div>
                <!-- Bouton Reset -->
                <div class="resett-btn">
                  <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                    title="Réinitialiser">
                    <a (click)="onReset()">
                      <img src="/assets/media/icons/reset.png" alt="" width="30px" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
  <!--begin::Content container-->
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="card content-table">
      <!--begin::Card headeer-->

      <div class="card-body ">
        <div class="action-grid mb-5 mt-3 flex-wrap">
          <div class="section_title">
            <h1 class="section-heading my-0">Liste des abonnements</h1>
          </div>
          <div class="change-offre">
            <a class="m-2" (click)="!getButtonClass(activePlan) && CheckoutAddCard()" [ngClass]="getButtonClass(activePlan) ? 'disabled-button' : ''">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-euro"><path d="M4 10h12"/><path d="M4 14h9"/><path d="M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2"/></svg> 
              Mode de paiement
            </a>
            <a routerLink="/changer-offre" class="m-2">
              <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-pen-line"><path d="m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2"/><path d="M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"/><path d="M8 18h1"/></svg>
              Changer offre
            </a>
          </div>
        </div>
        <div class="d-flex justify-content-end">
                        <ul class="nav nav-pills me-5" *ngIf="listAbonnement && listAbonnement.length">
                            <li class="nav-item m-0">
                                <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3"
                                    data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                                    <i class="ki-duotone ki-element-plus fs-1">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                        <span class="path3"></span>
                                        <span class="path4"></span>
                                        <span class="path5"></span>
                                    </i>
                                </a>
                            </li>
                            <li class="nav-item m-0">
                                <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                                    data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                                    <i class="ki-duotone ki-row-horizontal fs-2">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>
                                </a>
                            </li>
                        </ul>
                    </div>
        <div>
        <div class="card-body pt-0 pb-0">
          <div class="tab-content for-web">
            <div id="kt_project_targets_card_pane" class="tab-pane fade ">
              <div class="row g-6 g-xl-9 justify-content-center">
                <div class="col-md-6 col-xxl-4" *ngFor="let abonnement of listAbonnement">
                     <div class="card pt-5 p-5">
                      <!--begin::Card body-->
                        <div class="dropdown">
                                  <button
                                      class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                      type="button"
                                      id="dropdownMenuButton"
                                      data-bs-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false">
                                      <svg width="19" height="5"
                                          viewBox="0 0 19 5" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="2.44739"
                                              cy="2.44739" r="2.44739"
                                              transform="matrix(1 0 0 -1 0 4.89478)"
                                              fill="#265D91" />
                                          <circle cx="2.44739"
                                              cy="2.44739" r="2.44739"
                                              transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                              fill="#265D91" />
                                          <circle cx="2.44739"
                                              cy="2.44739" r="2.44739"
                                              transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                              fill="#265D91" />
                                      </svg>
                                  </button>
                                  <div class="dropdown-menu"
                                      aria-labelledby>
                                      <a class="dropdown-item"
                                          (click)="!isTrial(abonnement) && navigateToDetails(abonnement?.uuid)"
                                          [ngClass]="isTrial(abonnement) ? 'disabled-button' : ''"
                                          [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                                          style="cursor: pointer;">
                                          Visualiser
                                      </a>
                                      <a class="dropdown-item"
                                          class="dropdown-item" routerLink="/invoices"  [ngClass]="isTrial(abonnement) ? 'disabled-button' : ''"
                                           [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                                          (click)="!isTrial(abonnement) && navigateToInvoiceHistory(abonnement?.uuid, abonnement?.stripe_subscription?.id)">
                                          Historique Factures
                                      </a>
                                      <a class="dropdown-item"
                                          class="dropdown-item"
                                          [ngClass]="getButtonClass(abonnement)"
                                          [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                                          (click)="handleResiliation(abonnement, resilier)">
                                          Résilier
                                      </a>
                                  </div>
                        </div>
                      <div class="card-body d-flex flex-center flex-column gap-3">
                          <a (click)="navigateToDetails(abonnement?.uuid)"
                              class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0 cursor-pointer "><span
                                  class="first-td">{{ abonnement.plan?.name || '---' }}</span>
                          </a>
                          <span >prix : {{ (abonnement.plan.monthly_price) | currency:'EUR':'symbol':'1.2-2'}}</span>
                          <span class="remote"><span> Date début : {{
                                  abonnement.starts_at ?
                                  (abonnement.starts_at |
                                  date:'dd/MM/yyyy') : '---'
                                  }}</span></span>
                            
                            <span class="remote"><span> Date fin : {{
                                  abonnement.ends_at ?
                                  (abonnement.ends_at |
                                  date:'dd/MM/yyyy') : '---'
                                  }}</span></span>
                      </div>
                      <div class="sep"></div>
                      <div class="foot p-5">
                          <div class="plus">
                              <a (click)="navigateToDetails(abonnement?.uuid)"
                                  style="cursor: pointer;">Visualiser</a>
                          </div>
                      </div>
                 
                </div>
              </div>
               <app-empty-state *ngIf="listAbonnement && !listAbonnement.length" [title]="parentItem"></app-empty-state>
              <div class="pagination" *ngIf="listAbonnement && listAbonnement?.length">
                <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                  [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                  aria-label="Select page">
                </mat-paginator>
              </div>
             </div>
            </div>
            <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
              <div class="table-responsive mt-15" id="kt_customers_table" *ngIf="listAbonnement?.length">
                <table class="table align-middle gy-5 style-table" id="list_cra">
              <thead class="text-uppercase">
                <th class="min-w-125px">
                  <span>Nom Pack</span>
                </th>
                <th class="min-w-125px">
                  <span>Date d’abonnement</span>
                </th>
                <th class="min-w-125px">
                  <span>Date d'échéance</span>
                </th>
                <th class="min-w-125px">
                  <span> Prix(HT)</span>
                </th>
                <th class="min-w-125px">
                  <span>Statut</span>
                </th>
                <th class="min-w-125px">
                  <span>Actions</span>
                </th>
              </thead>

              <tbody>
                <tr *ngFor="let abonnement of listAbonnement">
                  <td (click)="navigateToDetails(abonnement?.uuid)">
                    <span class="first-td">{{ abonnement.plan?.name || '---' }}</span>
                  </td>

                  <td>
                    <span>{{ abonnement.starts_at | date: 'dd/MM/yyyy' }}</span>
                  </td>
                  <td>
                    <span>{{ abonnement.ends_at | date: 'dd/MM/yyyy' }}</span>
                  </td>

                  <td>
                    <span >
                      {{ (abonnement.plan.monthly_price) | currency:'EUR':'symbol':'1.2-2'}}
                    </span>
                  </td>
                  <td>
                    <span
                      [ngClass]="{
                        badge: true,
                        active: abonnement.state === 'active',
                        inactive: abonnement.state === 'inactive',
                        cancel_scheduled: abonnement.state === 'cancel_scheduled',
                        canceled: abonnement.state === 'canceled'
                      }"
                    >
                      <i class="fa-solid fa-circle"></i>
                      <ng-container [ngSwitch]="abonnement.state">
                        <span *ngSwitchCase="'active'">Actif</span>
                        <span *ngSwitchCase="'inactive'">Inactif</span>
                        <span *ngSwitchCase="'cancel_scheduled'">Annulation prévue</span>
                        <span *ngSwitchCase="'canceled'">Annulé</span>
                        <span *ngSwitchDefault>État inconnu</span>
                      </ng-container>
                    </span>
                  </td>
                                   

                  <td>
                 
                        <button mat-button [matMenuTriggerFor]="menu"
                          class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                          type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                          aria-expanded="false">
                          <svg width="19" height="5" viewBox="0 0 19 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                            <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                            <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                          </svg>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item class="dropdown-item" (click)="!isTrial(abonnement) && navigateToDetails(abonnement?.uuid)"
                          [ngClass]="isTrial(abonnement) ? 'disabled-button' : ''"
                          [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                          >
                            Visualiser
                          </button>

                          <button mat-menu-item class="dropdown-item" routerLink="/invoices"  [ngClass]="isTrial(abonnement) ? 'disabled-button' : ''"
                            [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                           (click)="!isTrial(abonnement) && navigateToInvoiceHistory(abonnement?.uuid, abonnement?.stripe_subscription?.id)">
                            Historique Factures
                          </button>

                          <button
                            mat-menu-item
                            class="dropdown-item"
                            [ngClass]="getButtonClass(abonnement)"
                            [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                            (click)="handleResiliation(abonnement, resilier)"
                          >
                            Résilier
                          </button>
                        </mat-menu>
                  </td>
                </tr>
              </tbody>

                </table>
              </div>
              <app-empty-state *ngIf="listAbonnement && !listAbonnement.length" [title]="parentItem"></app-empty-state>
              <div class="pagination" *ngIf="listAbonnement && listAbonnement?.length">
            <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
              [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
              aria-label="Select page">
            </mat-paginator>
              </div>
            </div>
          </div>
           <div class="tab-content for-mobile">
              <div id="kt_project_targets_card_pane" class="tab-pane fade show active">

                <div class="row g-6 g-xl-9 justify-content-center">
                <div class="col-md-6 col-xxl-4" *ngFor="let abonnement of listAbonnement">
                     <div class="card pt-5 p-5">
                      <!--begin::Card body-->
                        <div class="dropdown">
                                  <button
                                      class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                      type="button"
                                      id="dropdownMenuButton"
                                      data-bs-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false">
                                      <svg width="19" height="5"
                                          viewBox="0 0 19 5" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="2.44739"
                                              cy="2.44739" r="2.44739"
                                              transform="matrix(1 0 0 -1 0 4.89478)"
                                              fill="#265D91" />
                                          <circle cx="2.44739"
                                              cy="2.44739" r="2.44739"
                                              transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                              fill="#265D91" />
                                          <circle cx="2.44739"
                                              cy="2.44739" r="2.44739"
                                              transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                              fill="#265D91" />
                                      </svg>
                                  </button>
                                  <div class="dropdown-menu"
                                      aria-labelledby>
                                      <a class="dropdown-item"
                                          (click)="!isTrial(abonnement) && navigateToDetails(abonnement?.uuid)"
                                          [ngClass]="isTrial(abonnement) ? 'disabled-button' : ''"
                                          [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                                          style="cursor: pointer;">
                                          Visualiser
                                      </a>
                                      <a class="dropdown-item"
                                          class="dropdown-item" routerLink="/invoices"  [ngClass]="isTrial(abonnement) ? 'disabled-button' : ''"
                                           [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                                          (click)="!isTrial(abonnement) && navigateToInvoiceHistory(abonnement?.uuid, abonnement?.stripe_subscription?.id)">
                                          Historique Factures
                                      </a>
                                      <a class="dropdown-item"
                                          class="dropdown-item"
                                          [ngClass]="getButtonClass(abonnement)"
                                          [ngbTooltip]="isTrial(abonnement) ? 'Votre abonnement ne vous permet pas cette action' : null"
                                          (click)="handleResiliation(abonnement, resilier)">
                                          Résilier
                                      </a>
                                  </div>
                        </div>
                      <div class="card-body d-flex flex-center flex-column gap-3">
                          <a (click)="navigateToDetails(abonnement?.uuid)"
                              class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0 cursor-pointer "><span
                                  class="first-td">{{ abonnement.plan?.name || '---' }}</span>
                          </a>
                          <span >prix HT: {{ (abonnement.plan.monthly_price) | currency:'EUR':'symbol':'1.2-2'}}</span>
                          <span class="remote"><span> Date début : {{
                                  abonnement.starts_at ?
                                  (abonnement.starts_at |
                                  date:'dd/MM/yyyy') : '---'
                                  }}</span></span>
                            
                            <span class="remote"><span> Date fin : {{
                                  abonnement.ends_at ?
                                  (abonnement.ends_at |
                                  date:'dd/MM/yyyy') : '---'
                                  }}</span></span>
                      </div>
                      <div class="sep"></div>
                      <div class="foot p-5">
                          <div class="plus">
                              <a (click)="navigateToDetails(abonnement?.uuid)"
                                  style="cursor: pointer;">Visualiser</a>
                          </div>
                      </div>
                 
                </div>
              </div>
               <app-empty-state *ngIf="listAbonnement && !listAbonnement.length" [title]="parentItem"></app-empty-state>
              <div class="pagination mt-5 pt-5" *ngIf="listAbonnement && listAbonnement?.length">
                <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                  [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                  aria-label="Select page">
                </mat-paginator>
              </div>


              </div>
          </div>
        </div>
          
        </div>
      </div>
    </div>
  </div>
  <!--end::Content container-->
</div>
<ng-template #resilier>
  <div class="modal-content pt-5  pb-5" id="resilier">
    <!--begin::Modal header-->
    <div class="modal-header">
      <!--begin::Modal title-->
      <h2 class="fw-bold">Resilier votre abonnement</h2>
      <!--end::Modal title-->
      <!--begin::Close-->
      <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary">
        <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <!--end::Close-->
    </div>
    <!--end::Modal header-->
    <!--begin::Modal body-->
    <div class="modal-body mx-5 my-7">
      <!--begin::Form-->
      <label for="pourquoi">Pourquoi voulez-vous résilier votre abonnement ?
      </label>
      <textarea name="pourquoi" id="pourquoi" class="form-control style-input"
        placeholder="Pourquoi voulez-vous résilier votre abonnement ?" [(ngModel)]="cancelSubscriptionElement"></textarea>
      <!--end::Form-->
    </div>
    <div class="modal-footer mx-5">
      <div class="actions">
        <button class="annuler" (click)="closeModal()">Annuler</button>
        <button class="confirmer" (click)="cancelSubscription()"
          [disabled]="!cancelSubscriptionElement">Confirmer</button>
      </div>
    </div>
    <!--end::Modal body-->
  </div>
</ng-template>
